import React, { useState } from "react";
import './style.scss';
import TeamData from "../../../Component/Team/TeamData";
import { image } from "../../../Assets";

const Team = () => {
  // Track which team member is expanded
  const [expandedMember, setExpandedMember] = useState(null);

  const toggleExpand = (index) => {
    if (expandedMember === index) {
      // If already expanded, collapse it
      setExpandedMember(null);
    } else {
      // Expand this member
      setExpandedMember(index);
    }
  };

  return (
    <>
      <section className="text-page-head tw-py-20">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <h2 className="tw-text-[#157438] ">Meet our <br />team members</h2>              
            </div>
            <div className="col-lg-8 col-12">
              <p>
                At Fractile, our success is driven by the exceptional individuals who make up our diverse and talented team.
                Get to know the faces behind our innovative solutions and collaborative approach. Meet the experts dedicated
                to exceeding your expectations and delivering outstanding results.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-page-section">
        <div className="container">
          <div className="row">
            {TeamData.map((obj, index) => (
              <div key={index} className="col-lg-12 col-12 mb-4">
                <div className="team-member row">
                  <div className="teamwrapper col-lg-4 col-12">
                    <img src={obj.img} alt={obj.name} />
                  </div>
                  <div className="col-lg-8 col-12 c-order-2 d-flex align-items-center">
                    <div className="w-100 tw-relative">
                      <div className="tw-w-14 tw-h-14 tw-bg-[#157438] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-absolute tw-right-0 tw-scale-1 hover:tw-scale-[1.05]">
                        <a href={obj.linkedinurl} target="_blank"><img src={image.linkedincon} alt="" className="tw-w-6 tw-h-6 "/></a>
                      </div>
                      <div className="mb-3">
                        <h3 className="tw-text-[#157438]"><b>{obj.name}</b></h3>
                        <h6>{obj.title}</h6>
                      </div>
                      <p
                        style={
                          expandedMember === index 
                            ? {
                                // Expanded state - show all content
                                overflow: "visible",
                                display: "block"
                              }
                            : {
                                // Collapsed state - truncate
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                marginBottom: "20px"
                              }
                        }
                      >
                        {obj.about}
                      </p>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: '80px', paddingTop: '15px' }}
                      >
                        <div>
                          <button 
                            className="btn-2" 
                            onClick={() => toggleExpand(index)} 
                            style={{width:"150px"}}
                          >
                            {expandedMember === index ? "Read Less" : "Read More"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Team;